<article class="insights-viewer-card card col-12 p-0">
  <header class="card-header insights-viewer-header d-flex flex-column gap-2">
    <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
      <div>
          @if(insight().subject?.title){
            <p class="small text-muted mb-1">{{insight().subject.title}}</p>
          }
            <h4 class="mb-0">{{ insight().s}}</h4>
      </div>
      <div class="d-flex flex-wrap gap-1">
        @if (showId()) {
          <span class="badge rounded-pill text-bg-light">ID {{ insight()?.id }}</span>
        }
        @if (showSlug()) {
          <span class="badge rounded-pill text-bg-light">{{ insight()?.slug }}</span>
        }
        @if (showCategory() && insight()?.category) {
          <span class="badge rounded-pill text-bg-info">{{ insight()?.category }}</span>
        }
        @if (showType() && insight()?.type) {
          <span class="badge rounded-pill text-bg-info">{{ insight()?.type }}</span>
        }
      </div>
    </div>

    @if (showCultures() || showDifferences() || showTopics()) {
      <div class="insights-meta-row">
        @if (showCultures()) {
          <!-- <span class="fw-semibold" *transloco="let t">{{t('common.cultures')}}</span> -->
          @if (insight().cultures?.length) {
            @for (culture of insight().cultures; track culture.id) {
              <multisite-avatar-pill
                [fallbackImageUrl]="getCultureFlagUrl(culture)"
                [fallbackTranslationKey]="'tracking.missing'"
                [imageUrl]="getCultureFlagUrl(culture)"
                [text]="culture.name"
                [compact]="true">
              </multisite-avatar-pill>
            }
          } @else {
            <span *transloco="let t">{{t('common.none')}}</span>
          }
        }
        @if (showDifferences() && insight().differences?.length) {
          <!-- <span class="fw-semibold" *transloco="let t">{{t('content.cultural_differences')}}</span> -->
          @for( difference of insight().differences; track difference.id) {
            <span class="badge rounded-pill text-bg-secondary">{{ difference.name }}</span>
          }
        }
        @if (showTopics() && insight().topics?.length) {
          @for (topic of insight().topics; track topic.id) {
              <multisite-icon-pill
                [icon]="topic.icon"
                [labelText]="topic.name"
                [selectable]="false"
                [inverted]="false"
                [shape]="'round'"
                [compact]="true">
              </multisite-icon-pill>
          }
        }
      </div>
    }

    @if (showAvailableTranslations()) {
      <div class="insights-viewer-translations">
        @for (row of translationCoverage(); track row.field) {
          <div class="insights-viewer-translations__row">
            <span class="insights-viewer-translations__label small text-muted">{{ row.label }}</span>
            @if (row.hasAnyLocale) {
              @for (cell of row.locales; track cell.locale) {
                <span
                  class="badge rounded-pill text-uppercase"
                  [class.text-bg-success]="cell.exists"
                  [class.text-bg-light]="!cell.exists"
                  [class.opacity-50]="!cell.exists"
                  >{{ cell.locale }}</span
                >
              }
            } @else {
              <span class="small text-muted fst-italic">empty</span>
            }
          </div>
        }
        @if (showSendForTranslation()) {
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="requestSendForTranslation()">
            Send for translation
          </button>
        }
      </div>
    }
  </header>

  <section class="card-body">
    <div class="insights-viewer-body-layout">
    @if (currentImage(); as image) {
      <figure class="insights-viewer-image m-0" [class.insights-viewer-image--collapsed]="isBodyCollapsed()">
        <div class="insights-viewer-image__frame">
          <img
            class="insights-viewer-image__img"
            [src]="image | imageUrl : 'w_800,c_fill'"
            [alt]="image.alt_text || displayTitle()" />
          @if (image.role) {
            <span class="insights-viewer-image__role badge rounded-pill text-bg-dark">{{ image.role }}</span>
          }
          <figcaption class="insights-viewer-image__details">
            @if (image.title) {
              <p class="fw-semibold mb-1">{{ image.title }}</p>
            }
            @if (image.alt_text) {
              <p class="small mb-1">{{ image.alt_text }}</p>
            }
            @if (image.caption) {
              <p class="small mb-1">{{ image.caption }}</p>
            }
            @if (image.credits) {
              <p class="small mb-1 text-white-50">{{ image.credits }}</p>
            }
            @if (image.licence) {
              <p class="small mb-0 text-white-50">{{ image.licence }}</p>
            }
          </figcaption>
        </div>
        @if (hasMultipleImages()) {
          <div class="insights-viewer-image__controls d-flex justify-content-between align-items-center mt-2">
            <span class="small text-muted">{{ currentImagePosition() }} / {{ images().length }}</span>
            <button class="btn btn-sm btn-outline-primary" type="button" (click)="requestNextImage()">
              Next
            </button>
          </div>
        }
      </figure>
    }
    <div class="insights-viewer-body-content">
      <h5>{{ displayTitle() }}</h5>
      <div
        #bodyEl
        class="insights-viewer-html"
        [class.collapsed]="isBodyCollapsed()"
        [style.--collapsed-max-height]="collapsedBodyMaxHeightPx + 'px'"
        [innerHTML]="getInsightBodyMarkdown() | insightMarkdown"></div>
    </div>
    </div>
    <div class="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
      <p class="mb-0 small text-muted">Created: {{ insight()?.created_at | date : 'medium' }} | Updated: {{ insight()?.updated_at | date : 'medium' }}</p>
      @if (showBodyToggle()) {
        <button class="btn btn-sm btn-outline-primary" type="button" (click)="requestBodyExpandedToggle()">
          {{ isBodyExpanded() ? 'Collapse' : 'Expand' }} body
        </button>
      }
    </div>
  </section>
</article>
